import { gql, useQuery } from '@apollo/client';

import MultiSelectDropdown, { MultiSelectDropdownProps, Option } from './MultiSelectDropdown';

export interface PortaTagDropdownProps<T extends string | number | null>
  extends Omit<MultiSelectDropdownProps<T>, 'options' | 'newOption'> {
  /** id of dropdown tag category */
  category: string;
}

const TAGQUERY = gql`
  query UIKitPortalTags {
    portalTagCategoriesList {
      id
      Name
      DisplayName
      Tags {
        id
        Name
        DisplayName
      }
    }
  }
`;

export default function PortalTagMultiSelectDropdown<T extends string | number | null>(
  props: PortaTagDropdownProps<T>,
) {
  const { category, values, ...otherProps } = props;

  const { data } = useQuery(TAGQUERY);

  let tagOptions: Array<Option<T>> = [];
  if (data?.portalTagCategoriesList) {
    const cat = data?.portalTagCategoriesList.find((f) => f.Name === category);
    if (cat) {
      tagOptions =
        cat.Tags.map((t) => ({
          value: t.id,
          label: t.DisplayName,
        })) || [];
    }
  }

  const tagValues = values.filter((v) => tagOptions.find((t) => t.value === v.value));

  return <MultiSelectDropdown options={tagOptions} values={tagValues} {...otherProps} />;
}
